module.exports = __webpack_public_path__ + "img/baml-logo.c0644ca9.png";